import { render, staticRenderFns } from "./Byu4you.vue?vue&type=template&id=4040c94d&"
import script from "./Byu4you.vue?vue&type=script&lang=js&"
export * from "./Byu4you.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Byu4you.vue"
export default component.exports